import {
  ChangeDetectionStrategy,
  Component,
  InputSignal,
  ViewChild,
  ViewEncapsulation,
  input,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapComponent, MarkerComponent } from 'ngx-mapbox-gl';
import { Location } from '@clientwire/api';
import { InViewportModule } from 'ng-in-viewport';

@Component({
  selector: 'shared-message-map',
  standalone: true,
  imports: [CommonModule, InViewportModule, MapComponent, MarkerComponent],
  templateUrl: './message-map.component.html',
  styleUrl: './message-map.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageMapComponent {
  public centerCoordinates: InputSignal<Location> = input.required<Location>();
  readonly visible = signal<boolean>(false);

  @ViewChild('mapEl') mapboxMap?: MapComponent;

  public onIntersection({ visible }: { target: Element; visible: boolean }): void {
    this.visible.set(visible);
  }
}
